var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 500,
    viewBox: "0 0 840 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#0a3c19",
    stroke: "#000",
    strokeWidth: 0,
    x: 0,
    y: 0,
    width: 840,
    height: 500,
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    stroke: "#000",
    x: 482.03237,
    y: 245.62368,
    id: "svg_2",
    strokeWidth: 0,
    fontSize: 90,
    fontFamily: "'Arial Black'",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "normal",
    fontStyle: "normal",
    transform: "matrix(2.92914, 0, 0, 2.92914, -1312.53, -385.921)"
  }, "TIFF"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/tiff.5c83344a.svg";
export { ForwardRef as ReactComponent };